interface KindeAppConfig {
  authDomain: string;
  clientId: string;
  logoutRedirectURL: string;
  redirectURL: string;
}

export const KindeConfigurations: Record<string, KindeAppConfig> = {
  localhost: {
    clientId: '71167980b445478a8a7de7e1c886ae47',
    authDomain: 'https://empathy-dev.eu.kinde.com',
    redirectURL: 'http://localhost:4200/sign-in',
    logoutRedirectURL: 'http://localhost:4200'
  },
  'mom-dev.empathyiq.ie': {
    clientId: '71167980b445478a8a7de7e1c886ae47',
    authDomain: 'https://empathy-dev.eu.kinde.com',
    redirectURL: 'https://mom-dev.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://mom-dev.empathyiq.ie'
  },
  'mom-test.empathyiq.ie': {
    clientId: '78970995dce94ea588773470a371d845',
    authDomain: 'https://empathy-test.eu.kinde.com',
    redirectURL: 'https://mom-test.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://mom-test.empathyiq.ie'
  },
  'mom-qa.empathyiq.ie': {
    clientId: 'b86ac29b43bc4b8b86d537337edc1f02',
    authDomain: 'https://empathy-qa.eu.kinde.com',
    redirectURL: 'https://mom-qa.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://mom-qa.empathyiq.ie'
  },
  'mom-staging.empathyiq.ie': {
    clientId: '58e069683aff42e2afbcb877b2d33d17',
    authDomain: 'https://empathy-staging.eu.kinde.com',
    redirectURL: 'https://mom-staging.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://mom-staging.empathyiq.ie'
  },
  'mom.empathyiq.ie': {
    clientId: '271949805e3b45e6bd3f7b78c3b5b4de',
    authDomain: 'https://auth.empathyiq.ie',
    redirectURL: 'https://mom.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://mom.empathyiq.ie'
  },
  'shoptalk-staging.empathyiq.ie': {
    clientId: '7fbab19bcc6f4b98a673e0bcc733053c',
    authDomain: 'https://empathymus01-test.eu.kinde.com',
    redirectURL: 'https://shoptalk-staging.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://shoptalk-staging.empathyiq.ie'
  },
  'shoptalk.empathyiq.ie': {
    clientId: '6381a560c2bb42a6af757f911f1c4ef8',
    authDomain: 'https://empathymus01.kinde.com',
    redirectURL: 'https://shoptalk.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://shoptalk.empathyiq.ie'
  },
  'ukomnibus.empathyiq.ie': {
    clientId: '242627a141964eec89489d067fe1b682',
    authDomain: 'https://ukomnibusgroup.kinde.com',
    redirectURL: 'https://ukomnibus.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://ukomnibus.empathyiq.ie'
  },
  'bordbia.empathyiq.ie': {
    clientId: '53b8eb38462f4effb046db95454f1494',
    authDomain: 'https://bordbia.kinde.com',
    redirectURL: 'https://bordbia.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://bordbia.empathyiq.ie'
  },
  'demo.empathyiq.ie': {
    clientId: '254e2d1260ee40c88487ff214158c581',
    authDomain: 'https://empathyiqdemo.kinde.com',
    redirectURL: 'https://demo.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://demo.empathyiq.ie'
  },
  'iese.empathyiq.ie': {
    clientId: 'e6cc9bb6725f47698673c38081284450',
    authDomain: 'https://empathyiqiese.kinde.com',
    redirectURL: 'https://iese.empathyiq.ie/sign-in',
    logoutRedirectURL: 'https://iese.empathyiq.ie'
  }
};
